import { useFormContext } from "react-hook-form";

export const usePhoneInput = () => {
  const { control } = useFormContext();
  return {
    control,
  };
};
